import { Link, useNavigate } from "react-router-dom";
import { useWishlist } from "../context/WishlistContext";
import { useAuth } from "../context/AuthContext";
import ProductCard from "../components/ProductCard";
import { Button } from "../components/ui/button";
import { Heart, ShoppingBag } from "lucide-react";

export default function WishlistPage() {
  const { wishlist, loading } = useWishlist();
  const { user, loading: authLoading } = useAuth();
  const navigate = useNavigate();

  if (authLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="min-h-screen bg-cotton-100 flex items-center justify-center">
        <div className="text-center">
          <Heart className="w-16 h-16 text-muted-foreground mx-auto mb-4" />
          <h2 className="font-heading text-2xl font-bold mb-2">Please Login</h2>
          <p className="text-muted-foreground mb-6">
            Login to view and manage your wishlist
          </p>
          <Button
            onClick={() => navigate("/auth?redirect=/wishlist")}
            className="bg-primary hover:bg-primary/90 rounded-full"
            data-testid="login-btn"
          >
            Login to Continue
          </Button>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!wishlist.items || wishlist.items.length === 0) {
    return (
      <div className="min-h-screen bg-cotton-100 flex items-center justify-center">
        <div className="text-center">
          <Heart className="w-16 h-16 text-muted-foreground mx-auto mb-4" />
          <h2 className="font-heading text-2xl font-bold mb-2">Your wishlist is empty</h2>
          <p className="text-muted-foreground mb-6">
            Save items you like to your wishlist
          </p>
          <Button
            asChild
            className="bg-primary hover:bg-primary/90 rounded-full"
            data-testid="explore-btn"
          >
            <Link to="/products">
              <ShoppingBag className="w-4 h-4 mr-2" />
              Explore Products
            </Link>
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-cotton-100 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="font-heading text-3xl md:text-4xl font-bold mb-2" data-testid="wishlist-title">
          My Wishlist
        </h1>
        <p className="text-muted-foreground mb-8">
          {wishlist.items.length} item{wishlist.items.length !== 1 ? "s" : ""} saved
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-8 gap-y-12" data-testid="wishlist-grid">
          {wishlist.items.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </div>
    </div>
  );
}
